"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERACTIVE = void 0;
const INTERACTIVE = exports.INTERACTIVE = {
  OUTLINE_WEIGHT: '3px',
  OUTLINE_TRANSITION_DURATION: '0.1s',
  OUTLINE_TRANSITION_EASING: 'linear'
};